import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RadioGroup } from '@anyui/core';
import { useUserRoles } from '@anytag/auth';
import { ProposalJobDescriptionBreakDownMode } from '@anytag/graphql';
import { Button, Radio, SplitButton } from '@anytag/shared-atoms';
import { useProposedInfluencersSearch } from './hooks';
import { ProposeInfluencersFormValues, ProposeInfluencersTableMode } from './schemaTypes';

export interface ProposeInfluencersTableModesProps {
  onShowConfirmModal: () => void;
  jdMode?: ProposalJobDescriptionBreakDownMode;
  onEditJdMode: (mode: ProposalJobDescriptionBreakDownMode) => void;
}

export const ProposeInfluencersTableModes = ({
  jdMode,
  onEditJdMode,
  onShowConfirmModal
}: ProposeInfluencersTableModesProps) => {
  const { t } = useTranslation();
  const { isAdminStaffTalentAgencyPartner } = useUserRoles();
  const { setFilter, isEditMode, isViewMode } = useProposedInfluencersSearch();
  const {
    formState: { isSubmitting, isDirty }
  } = useFormContext<ProposeInfluencersFormValues>();

  if (!isAdminStaffTalentAgencyPartner) return null;

  return (
    <div className="box-border flex h-12 items-center justify-between rounded-t-sm bg-white p-4 pt-2">
      <SplitButton
        options={[
          {
            title: t('View'),
            variant: 'outline',
            prefixIcon: { icon: 'hamburger-menu', size: 11 },
            onClick: () => {
              if (isDirty) {
                onShowConfirmModal();
              } else {
                setFilter({ tableViewMode: ProposeInfluencersTableMode.VIEW });
              }
            },
            isActive: isViewMode
          },
          {
            title: t('Budget Edit'),
            variant: 'outline',
            isActive: isEditMode,
            prefixIcon: { icon: 'eraser', size: 11 },
            onClick: () => setFilter({ tableViewMode: ProposeInfluencersTableMode.EDIT })
          }
        ]}
      />

      <div className="flex items-center">
        <p className="mr-2 text-sm leading-4.5">{t('SetBudgetBy')}:</p>
        <RadioGroup value={jdMode} onChange={(value) => onEditJdMode(value as ProposalJobDescriptionBreakDownMode)}>
          <Radio value={ProposalJobDescriptionBreakDownMode.SOCIAL_BREAKDOWN} label={t('Social Media')} />
          <Radio value={ProposalJobDescriptionBreakDownMode.INFLUENCER_BREAKDOWN} label={t('General.Influencer')} />
        </RadioGroup>
        <Button
          type="submit"
          variant="solid"
          title={t('Button.Save')}
          className="ml-2 px-4"
          disabled={!isDirty}
          loading={{ status: isSubmitting, title: t('Button.Saving') }}
        />
      </div>
    </div>
  );
};
